import { Dispatch, SetStateAction } from 'react';
import { ace_index } from '@axo/shared/data-access/types';
import { FilterSelect } from '../FilterSelect';
import { areObjectsDifferent } from '../../utils/compareObjects';
import { setPageNumber } from '../SearchResults';

interface Props {
  query: ace_index.FindInput;
  setQuery: Dispatch<SetStateAction<ace_index.FindInput>>;
  editable?: boolean;
}

export function CreatedAfter({ query, setQuery, editable = false }: Props) {
  const state = getCreatedAfter(query);
  const value =
    options.find((option) => !areObjectsDifferent(state, option.value)) ??
    options[0];

  return (
    <FilterSelect
      items={options}
      onSelect={(option) => setQuery(setCreatedAfter(option.value))}
      stringify={(option) => option.label}
      value={value}
      label="Created time"
      description="Filter when the application was created"
      disabled={!editable}
    />
  );
}

const options: { label: string; value: Value }[] = [
  { label: 'All', value: undefined },
  { label: 'Last day', value: { From: days(-1), FromStartOfDay: true } },
  { label: 'Last 2 days', value: { From: days(-2), FromStartOfDay: true } },
  { label: 'Last 7 days', value: { From: days(-7), FromStartOfDay: true } },
  { label: 'Last 30 days', value: { From: days(-30), FromStartOfDay: true } },
  { label: 'Last 60 days', value: { From: days(-60), FromStartOfDay: true } },
  { label: 'Last 90 days', value: { From: days(-90), FromStartOfDay: true } },
];

function days(days: number) {
  return days * 24 * 60;
}

function setCreatedAfter(offset: Value): SetStateAction<ace_index.FindInput> {
  return (query) => ({
    ...setPageNumber(1)(query),
    LoanApplicationCreatedAtOffset: offset,
  });
}

function getCreatedAfter(query: ace_index.FindInput) {
  return query.LoanApplicationCreatedAtOffset;
}

type Value = ace_index.FindInput['LoanApplicationCreatedAtOffset'];
